import ReactTouchableArea from './ReactTouchableArea';

class TouchableArea extends ReactTouchableArea {

    
}

TouchableArea.defaultProps = {...ReactTouchableArea.defaultProps, 
    debounceTime: 0,
}

export default TouchableArea;